<template>
  <Modal
    :visible="visible"
    :class="['billing-modal billing-subscription-modal', { 'is-saved': subscriptionSaved }]"
    @toggle="$emit('toggle', !!$event)"
    v-bind="$attrs"
  >
    <template #title>
      <slot :name="`${step}-title`">{{ defaultModalTitles[step] }}</slot>
    </template>
    <template #content="modal">
      <template v-if="step === 'success'">
        <slot name="success" v-bind="modal">
          <p>Your plan information was successfully saved.</p>
          <div class="flex-center wrap mt-8">
            <BaseButton class="button-primary" @click="modal.close">Close</BaseButton>
          </div>
        </slot>
      </template>
      <SubscriptionForm
        v-else
        @change-step="subscriptionFormStep = $event"
        @preview="$emit('preview', $event)"
        @select-billing-period="$emit('select-billing-period', $event)"
        @select-subscription-level="$emit('select-subscription-level', $event)"
        @save-payment-method="$emit('save-payment-method', $event)"
        @save-subscription="onSaveSubscription"
      >
        <template v-slot:[step]="form">
          <slot :name="step" v-bind="{ form, modal }" />
        </template>
      </SubscriptionForm>
    </template>
  </Modal>
</template>

<script>
import SubscriptionForm from '@/components/forms/SubscriptionForm';

export default {
  name: 'SubscriptionFormModal',
  components: { SubscriptionForm },
  inheritAttrs: false,
  model: {
    prop: 'visible',
    event: 'toggle',
  },
  props: {
    visible: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {
      /** @type {'payment' | 'plan' | 'preview'} */
      subscriptionFormStep: 'plan',
      /** @type {boolean} */
      subscriptionSaved: false,
    };
  },
  computed: {
    /**
     * @returns {Readonly<Record<'payment' | 'plan' | 'preview' | 'success', string>>}
     */
    defaultModalTitles() {
      return Object.freeze({
        payment: 'Add a Payment Method',
        plan: 'Choose a Plan',
        preview: 'Confirm Change',
        success: 'Success!',
      });
    },
    /**
     * @returns {'payment' | 'plan' | 'preview' | 'success'}
     */
    step() {
      return this.subscriptionSaved ? 'success' : this.subscriptionFormStep;
    },
  },
  methods: {
    /**
     * @param {'payment' | 'plan' | 'preview'} step
     * @returns {void}
     */
    onChangeStep(step) {
      this.subscriptionFormStep = step;
      this.$emit('change-step', step);
    },
    /**
     * @param {Subscription} subscription
     * @returns {void}
     */
    onSaveSubscription(subscription) {
      this.subscriptionSaved = true;
      this.$emit('save', subscription);
      this.$emit('save-subscription', subscription);
    },
  },
  watch: {
    step(step) {
      /** @type {HTMLElement | null} */
      const modal = document.querySelector('.modal.billing-subscription-modal');
      if (modal) {
        modal.scrollTop = 0;
      }
      this.$emit('change-step', step);
    },
    visible(visible) {
      if (visible) {
        // When showing the modal, make sure the form is shown instead of the success message
        this.subscriptionSaved = false;
      }
    },
  },
};
</script>
